import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import userService from '../../services/UserService';
export const initialState = {
    loading: false,
    message: '',
    list:null,
}
export const EmployeeListAll = createAsyncThunk('employee/list',async (data, { rejectWithValue }) => {
    try {
        const response = await userService.getUser(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})
export const EmployeeSlice = createSlice({
    name: 'Employee',
    initialState,
    reducers: {
        EmployeeListData: (state, action) => {
            state.loading = true
            state.list = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(EmployeeListAll.pending, (state) => {
                state.loading = false
            })
            .addCase(EmployeeListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})
export const {
    EmployeeListData,
} = EmployeeSlice.actions
export default EmployeeSlice.reducer